<template>
  <div class="loader-wrapper">
    <!-- inicio do loader -->
    <div class="loader-box">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <span>Carregando…</span>
    </div>
    <!-- final do loader -->
  </div>
</template>

<script>
export default {
  name:"TheLoader"
}
</script>

<style scoped>
  /* aparece depois de um instante: requisições rápidas não piscam a tela */
  .loader-wrapper {
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    background: rgba(244, 245, 248, .55);
    backdrop-filter: blur(2px);
    animation: loader-in .2s ease-out .25s both;
  }
  .loader-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 22px 28px;
    background: white;
    border: 1px solid var(--line);
    border-radius: 14px;
    box-shadow: var(--shadow-md);
  }
  .loader-box span {
    font-size: .85rem;
    font-weight: 600;
    color: var(--muted);
  }
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 44px;
    height: 44px;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 44px;
    height: 44px;
    border: 4px solid var(--jersey-yellow);
    border-radius: 50%;
    animation: lds-ring 1.1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: var(--jersey-yellow) transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes loader-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }
</style>
